import TimerIcon from "@material-ui/icons/Timer";
import { useTranslation } from "next-i18next";

interface TimeProps {
  estimatedTime: number;
}

function Time({ estimatedTime }: TimeProps) {
  const { t: tCommon } = useTranslation("common");

  return (
    <div className="flex flex-row items-center gap-1 text-white">
      <TimerIcon />
      <div>
        ~&nbsp;
        {tCommon("minutesShortWithCount", {
          count: estimatedTime,
        })}
      </div>
    </div>
  );
}

export default Time;
